// extracted by mini-css-extract-plugin
export default {"landing-nav":"LandingNav_landing-nav__iAHHk","landing-nav-link":"LandingNav_landing-nav-link__uuphr"};